module.exports = __webpack_public_path__ + "img/turbo_on.06b647a5.png";